/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { tokens } from '@neo4j-ndl/base';

import { type TypographyVariants } from '../typography';

type ValidationFunction = (
  value: string,
) => Promise<true | string> | true | string;

export async function validateValue(
  value: string,
  validate?: ValidationFunction,
): Promise<string | null> {
  if (!validate) {
    return null;
  }

  const validation = validate(value);

  let isValid: string | boolean;
  if (validation instanceof Promise) {
    isValid = await validation;
  } else {
    isValid = validation;
  }

  if (typeof isValid === 'string') {
    return isValid;
  }

  return null;
}

export function getIconSizeForVariant(variant: TypographyVariants): number {
  switch (variant) {
    case 'display':
    case 'title-1':
      return 24;
    case 'title-2':
    case 'title-3':
    case 'title-4':
    case 'subheading-large':
      return 20;
    default:
      return 16;
  }
}

export const getIconStyle = (
  variant: TypographyVariants,
): React.CSSProperties => ({
  height: `${getIconSizeForVariant(variant)}px`,
  width: `${getIconSizeForVariant(variant)}px`,
});

export const getMinHeight = (variant: TypographyVariants): string => {
  return `${tokens.typography[variant].lineHeight * parseFloat(tokens.typography[variant].fontSize)}rem`;
};
